/**
 * GSAP Form Fade In Up Animation
 * 
 * HOW TO USE:
 * This animation automatically targets all Gravity Forms fields.
 * No additional classes needed - it targets ".gform_fields .gfield" automatically.
 * 
 * WHAT IT DOES:
 * - Animates each form field (input, textarea, select, etc.) individually
 * - Each field fades in from below as the user scrolls down the form
 * - Creates a smooth, professional form reveal experience
 * 
 * EXAMPLE (automatic - no setup needed):
 * <form class="gform_wrapper">
 *   <ul class="gform_fields">
 *     <li class="gfield"><!-- This field will animate --></li>
 *     <li class="gfield"><!-- This field will animate --></li>
 *     <li class="gfield"><!-- This field will animate --></li>
 *   </ul>
 * </form>
 * 
 * ANIMATION DETAILS:
 * - Starts 30px below final position (y: 30)
 * - Fades from opacity 0 to 1
 * - Duration: 1 second
 * - Easing: power2.out (smooth deceleration)
 * - Triggers when field top reaches 99% of viewport height
 * - Plays once only per field
 */

// GSAP fade-in-up animation for form fields
const formFadeInUp = document.querySelectorAll(".gform_fields .gfield");
if (formFadeInUp.length) {
  gsap.utils.toArray(".gform_fields .gfield").forEach((element) => {
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 99%",
        end: "bottom 10%",
        toggleActions: "play none none none",
      },
    });
    
    tl.from(element, {
      duration: 1,
      opacity: 0,
      y: 30,
      ease: "power2.out",
    });
  });
}
